<template>
    <v-container class="d-flex justify-center align-center pa-0 fill-height">
        <v-icon v-if="isFavorite" color="primary" :icon="mdiStar" class="cursor-pointer" />
        <v-hover v-else v-slot="{ isHovering, props: hoverProps }">
            <v-icon v-bind="hoverProps" :icon="isHovering ? mdiStarOutline : undefined" color="primary" />
        </v-hover>
    </v-container>
</template>
<script setup>
    import { onBeforeMount, ref } from 'vue';
    import { mdiStar, mdiStarOutline } from "@mdi/js"

    const props = defineProps(['params']);

    const path = ref(null);
    const isFavorite = ref(false);
    const usersUrl = ref("/Users");
    const icon = ref("");

    onBeforeMount(() => {
        if (
            props.params.colDef.field == "favorite" &&
            props.params.node.rowPinned != "bottom"
        ) {
            let folderWithFiles =
                typeof props.params.node.data != "undefined" &&
                props.params.node.data.isFavorite;

            let notAFile =
                typeof props.params.node.data != "undefined" &&
                typeof props.params.node.data.path != "undefined" &&
                props.params.node.data.path.last().indexOf(".") == -1;

            let folderWithoutFiles =
                typeof props.params.node.data == "undefined" &&
                typeof props.params.node.parent.data != "undefined" &&
                props.params.node.parent.data.isFavorite;

            if (notAFile) icon.value = "star";

            if (folderWithFiles && notAFile) {
                path.value = props.params.node.data.path;
                isFavorite.value = true;
            } else if (folderWithoutFiles) {
                path.value = Array.from(props.params.node.parent.data).push(
                    props.params.node.key,
                );
                isFavorite.value = true;
            }
        }
    });

</script>
